module.exports = __webpack_public_path__ + "media/images/icons/vendors/band-73d415f1e62084c3bc85dde7d0fe455d.png";